import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  refreshRestorePointsVapp(vdcId, vappId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/vapp/' + vappId + '/refreshRestorePoints';
    return this.http
      .post(url, JSON.stringify({}))
      .map(
        (res: any) => this.value = res
      );
  }

  refreshRestorePointsDeletedVapp(vdcId, vappId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/deletedVApp/' + vappId + '/refreshRestorePoints';
    return this.http
      .post(url, JSON.stringify({}))
      .map(
        (res: any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/refresh-restore/refresh-restore.service.ts